import { useEditor, Frame } from '@craftjs/core';
import { useEffect } from 'react';
import slugify from 'slugify';
import '@/components/editor/reset.scss';

export interface Section {
  label: string;
  slug: string;
}

interface Props {
  json?: string;
  setSections: any;
}

const Canvas = ({ json, setSections }: Props) => {
  const {
    store: { query },
  } = useEditor();

  useEffect(() => {
    const sections: { label: string; slug: string }[] = [];

    if (json) {
      const nodes = query.getNodes();
      Object.values(nodes).forEach((node) => {
        if (node?.data?.displayName && node?.data?.props?.title) {
          sections.push({
            label: node.data.props.title,
            slug: slugify(node.data.props.title ?? '', { lower: true }),
          });
        }
      });
    }
    if (sections.length) setSections(sections);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <Frame data={json} />;
};

export default Canvas;
